// import axios from 'axios';
import api from '@/api';
import {
//
} from './mutation-types';

export default {
    // Open Badges v2 발급
    // eslint-disable-next-line no-unused-vars
    issueBadge ({ commit }, issue) {
        console.log('action! issue v2', issue);

        // return new Promise((resolve) => {
        //     const mockResponse = {
        //         status: 400,  // 400 응답을 강제로 줌
        //         data: 'Bad Request',
        //     };

        //     resolve(mockResponse);  // 여기에 resolve를 사용해서 then 블록으로 보내기
        // });


        // https://lecos.co.kr/api/v1/OpenBadges
        return api.post('/OpenBadges', issue, {
            headers: {
                'Accept-Language': issue.lang
            },
        });
    },

    // Open Badges v3 발급
    // eslint-disable-next-line no-unused-vars
    issueBadgeV3 ({ commit }, issue) {
        issue.company = 'lecos';
        console.log('action! issue v3', issue);

        // return new Promise((resolve) => {
        //     const mockResponse = {
        //         status: 400,  // 400 응답을 강제로 줌
        //         data: 'Bad Request',
        //     };

        //     resolve(mockResponse);  // 여기에 resolve를 사용해서 then 블록으로 보내기
        // });


        // https://lecos.co.kr/api/v1/OpenBadges
        // if (!issue.company) issue.company = 'lecos';
        return api.post('/OpenBadgesV3', issue, {
            headers: {
                'Accept-Language': issue.lang
            },
        });
    },
};
